import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faEnvelope, faComment, faEllipsisV, faEdit, faTrash, faBan } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Form, Button, InputGroup, Table, Badge, Dropdown, ButtonGroup, Spinner, Modal } from '@themesberg/react-bootstrap';
import api from '../../utils/api';
import { useHistory } from 'react-router-dom';

export default () => {
  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updatingId, setUpdatingId] = useState(null);
  const [updatingAll, setUpdatingAll] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [banningId, setBanningId] = useState(null);
  const [showBanModal, setShowBanModal] = useState(false);
  const [banTargetId, setBanTargetId] = useState(null);
  const [banTargetName, setBanTargetName] = useState(null);

  useEffect(() => {
    loadAccounts();
  }, []);

  const loadAccounts = async () => {
    try {
      setLoading(true);
      const response = await api.get('/users', {
        params: { isTestUser: true, limit: 1000 }
      });
      if (response.data && response.data.users) {
        const accountsList = response.data.users.map(data => ({
          id: data.uid || data.id || data._id,
          name: data.name || '',
          firstName: data.firstName || '',
          lastName: data.lastName || '',
          gender: data.gender || '',
          age: data.age || 0,
          status: data.isApproved || false,
          profileImageUrl: data.profileImageUrl || null,
          isBanned: data.isBanned || false,
          deviceId: data.deviceId || null,
          createdAt: data.createdAt || null
        }));
        setAccounts(accountsList);
      }
      setError(null);
    } catch (err) {
      console.error("Error loading accounts:", err);
      setError("Hesaplar yüklenirken hata oluştu: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  const toggleApprovalStatus = async (accountId, currentStatus) => {
    try {
      setUpdatingId(accountId);
      await api.put(`/users/${accountId}/admin-update`, {
        isApproved: !currentStatus
      });
      await loadAccounts();
    } catch (err) {
      console.error("Error updating approval status:", err);
      alert("Durum güncellenirken hata oluştu: " + err.message);
    } finally {
      setUpdatingId(null);
    }
  };

  const updateAllFakeAccountsToBoth = async () => {
    if (!window.confirm('Tüm fake hesapları "Her İkisi" listesine eklemek istediğinize emin misiniz?')) {
      return;
    }
    try {
      setUpdatingAll(true);
      setError(null);
      await api.post('/users/update-all-fake-accounts');
      alert(`Toplu güncelleme başarılı!`);
      await loadAccounts();
    } catch (err) {
      console.error("Error updating all fake accounts:", err);
      setError("Toplu güncelleme sırasında hata oluştu: " + err.message);
      alert("Toplu güncelleme sırasında hata oluştu: " + err.message);
    } finally {
      setUpdatingAll(false);
    }
  };

  const handleDeleteAccount = async (accountId, accountName) => {
    if (!window.confirm(`"${accountName}" kullanıcısını silmek istediğinize emin misiniz?`)) return;
    try {
      setDeletingId(accountId);
      setError(null);
      await api.delete(`/users/${accountId}`);
      alert(`"${accountName}" kullanıcısı ve tüm verileri başarıyla silindi!`);
      await loadAccounts();
    } catch (err) {
      console.error("Error deleting account:", err);
      setError("Hesap silinirken hata oluştu: " + err.message);
    } finally {
      setDeletingId(null);
    }
  };

  const handleBanUser = async (accountId, accountName, currentBanned) => {
    if (!window.confirm(currentBanned ? "Banı kaldırmak istediğinize emin misiniz?" : "Banlamak istediğinize emin misiniz?")) return;
    try {
      setBanningId(accountId);
      setError(null);
      await api.post('/users/update-ban', { userId: accountId, isBanned: !currentBanned });
      alert("İşlem başarılı.");
      await loadAccounts();
    } catch (err) {
      console.error("Error banning user:", err);
      setError("Kullanıcı banlanırken hata oluştu: " + err.message);
    } finally {
      setBanningId(null);
    }
  };

  const filteredAccounts = accounts.filter(account => {
    if (!searchTerm) return true;
    const searchLower = searchTerm.toLowerCase();
    return (
      account.name.toLowerCase().includes(searchLower) ||
      account.firstName?.toLowerCase().includes(searchLower) ||
      account.lastName?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <>
      <div className="py-4">
        <h4>Listele</h4>
        <p className="text-muted mb-0">Hesaplar / Listele</p>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body>
          <div className="alert alert-info mb-4">
            <strong>Uyarı:</strong> Bu özellikler test amaçlıyla kullanılmalıdır.
          </div>

          <Row className="mb-4">
            <Col md={6}>
              <InputGroup>
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Profil Ara..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </Col>
            <Col md={6} className="d-flex justify-content-end align-items-center">
              <Button
                variant="success"
                size="sm"
                onClick={updateAllFakeAccountsToBoth}
                disabled={updatingAll}
                className="me-2"
              >
                {updatingAll ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Güncelleniyor...
                  </>
                ) : (
                  "Tüm Fake Hesapları 'Her İkisi' Yap"
                )}
              </Button>
              <Button variant="primary" size="sm">
                <FontAwesomeIcon icon={faSearch} className="me-2" />
                Ara
              </Button>
              <Dropdown className="ms-2">
                <Dropdown.Toggle variant="outline-secondary" size="sm">
                  Tüm Profiller
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>Tüm Profiller</Dropdown.Item>
                  <Dropdown.Item>Kadın Profiller</Dropdown.Item>
                  <Dropdown.Item>Erkek Profiller</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>

          {loading ? (
            <div className="d-flex justify-content-center p-5">
              <Spinner animation="border" />
            </div>
          ) : (
            <div className="table-responsive">
              <Table className="table-dark table-hover mb-0" style={{ fontSize: '0.85rem' }}>
                <thead>
                  <tr>
                    <th className="border-0">#</th>
                    <th className="border-0">Profil</th>
                    <th className="border-0">Durum</th>
                    <th className="border-0">Ad Soyad</th>
                    <th className="border-0">Yaş</th>
                    <th className="border-0">Cinsiyet</th>
                    <th className="border-0">İşlemler</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredAccounts.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center p-4">
                        {searchTerm ? "Arama sonucu bulunamadı." : "Henüz test kullanıcısı eklenmemiş."}
                      </td>
                    </tr>
                  ) : (
                    filteredAccounts.map((account, index) => (
                      <tr key={account.id}>
                        <td>{index + 1}</td>
                        <td>
                          {account.profileImageUrl ? (
                            <img
                              src={account.profileImageUrl}
                              alt={account.name}
                              className="rounded-circle"
                              style={{ width: 40, height: 40, objectFit: 'cover' }}
                            />
                          ) : (
                            <div
                              className="rounded-circle bg-secondary d-inline-block"
                              style={{ width: 40, height: 40 }}
                            ></div>
                          )}
                        </td>
                        <td>
                          <Button
                            variant={account.status ? "success" : "danger"}
                            size="sm"
                            onClick={() => toggleApprovalStatus(account.id, account.status)}
                            disabled={updatingId === account.id}
                          >
                            {updatingId === account.id ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              account.status ? "Doğrulandı" : "Doğrulanmadı"
                            )}
                          </Button>
                        </td>
                        <td>{account.name}</td>
                        <td>{account.age}</td>
                        <td>
                          <Badge bg={account.gender === "Kadın" ? "danger" : "primary"} className="badge-sm">
                            {account.gender}
                          </Badge>
                        </td>
                        <td>
                          <ButtonGroup size="sm">
                            <Button
                              variant="primary"
                              title="Düzenle"
                              onClick={() => history.push(`/accounts/edit/${account.id}`)}
                            >
                              <FontAwesomeIcon icon={faEdit} />
                            </Button>
                            <Button
                              variant={account.isBanned ? "warning" : "danger"}
                              title={account.isBanned ? "Banı Kaldır" : "Banla"}
                              onClick={() => handleBanUser(account.id, account.name, account.isBanned)}
                              disabled={banningId === account.id}
                            >
                              {banningId === account.id ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                <FontAwesomeIcon icon={faBan} />
                              )}
                            </Button>
                            <Button
                              variant="danger"
                              title="Sil"
                              onClick={() => handleDeleteAccount(account.id, account.name)}
                              disabled={deletingId === account.id}
                            >
                              {deletingId === account.id ? (
                                <Spinner animation="border" size="sm" />
                              ) : (
                                <FontAwesomeIcon icon={faTrash} />
                              )}
                            </Button>
                          </ButtonGroup>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
